const openHamburger = document.querySelector('.open-burger');
const closeHamburger = document.querySelector('.close-burger');
const menuBurger = document.querySelector('.burger');
const burgerOverlay = document.querySelector('.header__overlay');

/**
 * Открывает бургер-меню и делает оверлей видимым.
 * Блокирует прокрутку страницы.
 */
const openBurgerMenu = () => {
  menuBurger.classList.add('burger--open');
  document.body.style.overflow = 'hidden';
  burgerOverlay.classList.add('header__overlay--visible');
};

/**
 * Закрывает бургер-меню и скрывает оверлей.
 * Разрешает прокрутку страницы.
 */
const closeBurgerMenu = () => {
  menuBurger.classList.remove('burger--open');
  document.body.style.overflow = 'auto';
  burgerOverlay.classList.remove('header__overlay--visible');
};

openHamburger.addEventListener('click', openBurgerMenu);
closeHamburger.addEventListener('click', closeBurgerMenu);
burgerOverlay.addEventListener('click', closeBurgerMenu); // Закрытие при клике по overlay
